import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { UploadStatus } from "../models/uploadStatus.model";
import { UploadStatusJSON } from "../models/json/uploadStatusJSON";
import { UserSaveJSON } from "../models/json/userSaveJSON";

export interface UploadBPOSTLabel {
    reference: string;
    recipient: UserSaveJSON;
    sender?: UserSaveJSON | string;
    deliveryMethod?: string;
    orderReference?: string;
    costCenter?: string;
    message?: string;
    status?: string;
    date?: string;
}

const BPOST_QUERY_PARAMS = {
    carrier: "BPOST",
};
@Injectable({
    providedIn: "root",
})
export class BPOSTSyncService {
    constructor(private httpClient: HttpClient) {}

    syncBPOSTLabels(uploadData: UploadBPOSTLabel[]): Observable<UploadStatus | null> {
        const params = new HttpParams({ fromObject: BPOST_QUERY_PARAMS });

        return this.httpClient
            .post<UploadStatusJSON | null>(
                `${environment.apiBase}/packages/upload`,
                { items: uploadData },
                { params },
            )
            .pipe(map((jsonResponse) => UploadStatus.fromJSON(jsonResponse)));
    }

    getLatestUploadStatus(): Observable<UploadStatus | null> {
        const params = new HttpParams({ fromObject: BPOST_QUERY_PARAMS });

        return this.httpClient
            .get<UploadStatusJSON | null>(`${environment.apiBase}/packages/upload/status/latest`, {
                params,
            })
            .pipe(map((jsonResponse) => UploadStatus.fromJSON(jsonResponse)));
    }

    getUploadStatusById(id: number): Observable<UploadStatus | null> {
        const apiUrl = `${environment.apiBase}/packages/upload/status/${id}`;
        return this.httpClient
            .get<UploadStatusJSON | null>(apiUrl)
            .pipe(map((jsonResponse) => UploadStatus.fromJSON(jsonResponse)));
    }

    stopSync(id: number): Observable<any> {
        return this.httpClient.post(`${environment.apiBase}/packages/upload/stop`, {
            id,
        });
    }
}
